import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default function updateComposition(context, composition, newContent) {
  composition.replaceContent(newContent);

  const customerId = composition.customerId;
  getCompositionsStore(context, customerId).replace(composition);
  context.stores.localCompositions.set(customerId, composition);
}
